import { render, staticRenderFns } from "./repairAndProblem.vue?vue&type=template&id=20903548&scoped=true"
import script from "./repairAndProblem.vue?vue&type=script&lang=js"
export * from "./repairAndProblem.vue?vue&type=script&lang=js"
import style0 from "./repairAndProblem.vue?vue&type=style&index=0&id=20903548&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20903548",
  null
  
)

export default component.exports